document.addEventListener("DOMContentLoaded", () => {
  const wishlistButtons = document.querySelectorAll(".wishlist-button");

  // Load existing wishlist from localStorage
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  // Update button states
  wishlistButtons.forEach((button) => {
    const productId = button.getAttribute("data-product-id");
    if (wishlist.includes(productId)) {
      button.classList.add("wishlist-added");
    }

    button.addEventListener("click", () => {
      toggleWishlist(productId, button);
    });
  });

  function toggleWishlist(productId, button) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  
    if (wishlist.includes(productId)) {
      wishlist = wishlist.filter((id) => id !== productId);
      button.classList.remove("wishlist-added");
      syncWishlistWithMetafields(productId, "remove");
    } else {
      wishlist.push(productId);
      button.classList.add("wishlist-added");
      syncWishlistWithMetafields(productId, "add");
    }
  
    // Save to localStorage
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }
});


async function syncWishlistWithMetafields(productId, action) {
  const customerAccessToken = getCustomerAccessToken();

  if (!customerAccessToken) {
    console.log("Not logged in; changes are stored in localStorage only.");
    return;
  }

  // Fetch the current wishlist metafield value
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  if (action === "add") {
    if (!wishlist.includes(productId)) wishlist.push(productId);
  } else if (action === "remove") {
    wishlist = wishlist.filter((id) => id !== productId);
  }

  try {
    const response = await fetch("/api/2023-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "<your-storefront-access-token>",
      },
      body: JSON.stringify({
        query: `
          mutation customerUpdate($input: CustomerUpdateInput!) {
            customerUpdate(input: $input) {
              customer {
                metafields(namespace: "custom", key: "wishlist") {
                  value
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `,
        variables: {
          input: {
            accessToken: customerAccessToken,
            metafields: [
              {
                namespace: "custom",
                key: "wishlist",
                type: "list.product_reference",
                value: JSON.stringify(wishlist),
              },
            ],
          },
        },
      }),
    });

    const result = await response.json();
    if (result.errors || result.data.customerUpdate.userErrors.length > 0) {
      console.error("Failed to sync wishlist:", result);
    } else {
      console.log("Wishlist synced successfully.");
    }
  } catch (error) {
    console.error("Error syncing wishlist with metafields:", error);
  }
}

function getUpdatedWishlist(productId, action) {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  if (action === "add") {
    wishlist.push(productId);
  } else {
    wishlist = wishlist.filter((id) => id !== productId);
  }
  return wishlist;
}

function getCustomerAccessToken() {
  // Implement a method to retrieve the customer access token
  // For example, using cookies or the Shopify authentication flow
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("customer_access_token"))
    ?.split("=")[1];
}
